<template>
  <div class="app-main">
    <!-- 路由视图或页面内容 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'KcMain'
}
</script>

<style scoped>
.app-main {
  flex: 1;
  display: flex;
  justify-content: center;

  background-image:  url('../../../assets/xxkc/lmbj.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80%;
}
</style>
